import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    COOKING_STEP_TAB_NAME,
    ITEM_TAB_NAME,
    PAGE_TAB_NAME_LIST,
    RECIPE_TAB,
} from '../../constant';
import { ErrorHandler } from '../ErrorHandler';
import RecipesListTab from './RecipesListTab';
import RecipeEditTab from './RecipeEditTab';
import CookingStepsListTab from './CookingStepsListTab';
import CookingStepEditTab from './CookingStepEditTab';
import Title from '../Title';
import NavigationTabs from '../../shared/NavigationTabs';
import { recipePageNavigationService } from '../../services/recipePageNavigationService';

const RecipePage = () => {
    const { i18n } = useTranslation();
    const [activeRoute, setActiveRoute] = useState('');
    const { tab, id } = useParams();

    useEffect(() => {
        setActiveRoute(`/${RECIPE_TAB}/${tab}/${id}/`);
    }, [tab, id]);

    try {
        if (!activeRoute) {
            return null;
        }
        return (
            <section className="workspace workspace__recipe">
                {id === PAGE_TAB_NAME_LIST ? (
                    <>
                        <Title titleValue={i18n.t('app.page.recipe.title')} />
                        <NavigationTabs navigationService={recipePageNavigationService} />
                    </>
                ) : null}
                {tab === ITEM_TAB_NAME ? (
                    id === PAGE_TAB_NAME_LIST ? <RecipesListTab /> : <RecipeEditTab />
                ) : null}
                {tab === COOKING_STEP_TAB_NAME ? (
                    id === PAGE_TAB_NAME_LIST ? <CookingStepsListTab /> : <CookingStepEditTab />
                ) : null}
            </section>
        );
    } catch (err) {
        console.log(err);
        return <ErrorHandler titleValue={i18n.t('app.page.profile.emptyData')} />;
    }
};

export default RecipePage;
